import store from '@store/index'

function TeamGuard(to, from, next) {
  let user = store.getters['auth/user'];
  if (!user) {
    next({ name: 'login' })
  } else {
    next()
  }
}

export default TeamGuard
